import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {ConsumptionAgentResultComponent} from '../../consumption-agent-result/consumption-agent-result.component';
import {CommonModule} from '@angular/common';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslatePipe} from '@brunata-angular/util';
import {BehaviorSubject} from 'rxjs';
import {ConsumptionAgentTranslated} from '../../consumption-agents-overview/consumption-agent.model';

@Component({
    selector: 'app-preview-result-modal',
    templateUrl: './preview-result-modal.component.html',
    styleUrl: './preview-result-modal.component.scss',
    imports: [CommonModule, ConsumptionAgentResultComponent, TranslatePipe],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewResultModalComponent {
    protected readonly activeModal: NgbActiveModal = inject(NgbActiveModal);

    protected readonly consumptionAgentTranslated$ =
        new BehaviorSubject<ConsumptionAgentTranslated | null>(null);
    @Input({required: true}) set previewConsumptionAgent(
        consumptionAgentTranslated: ConsumptionAgentTranslated,
    ) {
        this.consumptionAgentTranslated$.next(consumptionAgentTranslated);
    }
}
